module.exports = __webpack_public_path__ + "static/media/supplies.7c20d7b4.svg";